module.exports = __webpack_public_path__ + "img/121.2.8db59e46.png";